import React from 'react'
import Image from './Image'

// 根据类型判断-渲染块级元素样式 标题/列表/居中..
const BlockElement = function (props) {
  const { attributes, children, element, url } = props
  console.log(url, props, 'urlurlurlurl')
  const style = { textAlign: element.align, lineHeight: element.lineHeight }
  switch (element.type) {
    case 'block-quote':
      return (
        <blockquote style={style} {...attributes}>
          {children}
        </blockquote>
      )
    case 'bulleted-list':
      return (
        <ul style={style} {...attributes}>
          {(children || []).map((child) => {
            return <li>{child}</li>
          })}
        </ul>
      )
    case 'heading-one':
      return (
        <h1 style={style} {...attributes}>
          {children}
        </h1>
      )
    case 'heading-two':
      return (
        <h2 style={style} {...attributes}>
          {children}
        </h2>
      )
    // case 'list-item':
    //   return (
    //     <li style={style} {...attributes}>
    //       {children}
    //     </li>
    //   )
    case 'numbered-list':
      return (
        <ol style={style} {...attributes}>
          {(children || []).map((child) => {
            return <li>{child}</li>
          })}
        </ol>
      )
    case 'indent':
      return (
        <p style={{ ...style, textIndent: '2em' }} {...attributes}>
          {children}
        </p>
      )
    case 'link':
      return <Image {...props} />
    default:
      return (
        <p style={style} {...attributes}>
          {children}
        </p>
      )
  }
}

export default BlockElement
